export default __webpack_public_path__ + "static/media/heart_yellow.1681c49f.svg";